import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_content_card_left_img = _resolveComponent("content-card-left-img")!
  const _component_widget_block = _resolveComponent("widget-block")!

  return (!_ctx.contentList?.items || _ctx.contentList.items.length)
    ? (_openBlock(), _createBlock(_component_widget_block, {
        key: 0,
        class: "facebook-widget",
        title: _ctx.title,
        "show-divider": !!_ctx.title,
        "btn-label": _ctx.btnLabel,
        "btn-url": _ctx.btnUrl
      }, {
        default: _withCtx(() => [
          (!_ctx.contentList?.items)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "facebook-widget__loader"
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contentList.items, (item) => {
                return (_openBlock(), _createBlock(_component_content_card_left_img, {
                  content: item,
                  "show-title": false,
                  "show-lead": true,
                  "show-image": true,
                  "show-duration": true
                }, null, 8, ["content"]))
              }), 256))
        ]),
        _: 1
      }, 8, ["title", "show-divider", "btn-label", "btn-url"]))
    : _createCommentVNode("", true)
}